import { mapGetters } from 'vuex'
export default {
  name: 'RechargeInfoCard',
  components: {},
  // props: ['offer'],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'operator',
      'region',
      'recharge_account_id',
      'operators'
    ]),
    getOperatorLogo () {
      const el = this.operators.find(e => e.operator === this.operator)
      if (el) {
        return el.logo
      }
    }
  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/RechargeInfoCard/component.js